import { defineComponent } from 'vue';
import LoadingWrapper from '@/presentation/components/shared/loading-wrapper/loading-wrapper.vue';
import AuditorEntriesTable from '@/presentation/components/auditor/auditor-entries-table/auditor-entries-table.vue';
import AuditorEntriesOverviewCode from '@/presentation/components/auditor/auditor-entries-overview.code';

export default defineComponent({
	components: {
		LoadingWrapper,
		AuditorEntriesTable
	},
	setup: () => {
		const code = new AuditorEntriesOverviewCode();

		return {
			isLoading: code.isLoading
		};
	}
});
